import { render, staticRenderFns } from "./CPQuillEditor.vue?vue&type=template&id=7164834e&scoped=true"
import script from "./CPQuillEditor.vue?vue&type=script&lang=js"
export * from "./CPQuillEditor.vue?vue&type=script&lang=js"
import style0 from "./CPQuillEditor.vue?vue&type=style&index=0&id=7164834e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7164834e",
  null
  
)

export default component.exports